import ukUA from "antd/lib/locale/uk_UA";
import enGB from "antd/lib/locale/en_GB";
import ruRU from "antd/lib/locale/ru_RU";

export const antdLocale: any = {
	uk: ukUA,
	en: enGB,
	ru: ruRU,
}